import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import type React from "react";
import { INK } from "@/theme/tokens";

interface CancelShiftDialogProps {
	open: boolean;
	onClose: () => void;
	onConfirm: (cancelContained: boolean) => void;
}

export const CancelShiftDialog: React.FC<CancelShiftDialogProps> = ({ open, onClose, onConfirm }) => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth data-testid="cancel-shift-dialog">
			<DialogTitle sx={{ textAlign: "center", color: INK.SECONDARY }}>Overlapping Shifts Detected</DialogTitle>
			<DialogContent>
				<DialogContentText sx={{ textAlign: "center" }}>
					This shift overlaps with another one you've picked up. Can you still work the partial shift?
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ justifyContent: "center" }}>
				<Button onClick={() => onConfirm(true)} variant="outlined" data-testid="cancel-shift-cancel-all-button">
					No, cancel all
				</Button>
				<Button onClick={() => onConfirm(false)} variant="contained" color="primary" data-testid="cancel-shift-confirm-button">
					Yes, I can still work
				</Button>
			</DialogActions>
		</Dialog>
	);
};
